var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-table-panel"},[_c('exam-list',{ref:"webinarExamList",attrs:{"scene":"webinar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }